<template>
    <div class="spinner-control-block h-center">
        <b-spinner
            id = "spinner-control" 
            variant="light"
            type="grow"
            label = "Loading..." 
            :style="admin ? 'background-color: #00af00' : 'background-color: #93C660'"
        ></b-spinner>
    </div>
</template>

<script>
export default {
    props: {
        admin: {
            type: Boolean,
            default: true
        }
    }
}
</script>

<style>
.container-basic-spinner {
    margin-top: 35vh;
}
.container-tab-spinner {
    margin-top: 20vh;
}
</style>

